import { useMemo } from 'react';

import { EnabledWallet } from '#src/__generated__/globalTypes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

export const useSettlableWalletsSearch = () => {
  const { currentUser } = useCurrentUserContext();
  const enabledWallets = currentUser?.profile?.enabledWallets;
  const availableBalances = currentUser?.availableBalances;

  return useMemo(() => {
    if (enabledWallets && availableBalances) {
      if (
        enabledWallets.length === 1 &&
        enabledWallets[0] === EnabledWallet.FIAT
      ) {
        // if the user only configured their FIAT wallet, only display them cards they can settle in FIAT
        return 'fiat';
      }
      if (
        availableBalances.wei.wei &&
        availableBalances.wei.wei > 0n &&
        availableBalances.lamport.lamport === 0n
      ) {
        // if the user only configured their ETH wallet, still show them FIAT-only cards,
        // they might want to pay with by CC
        return 'fiat,eth';
      }
      if (
        availableBalances.lamport.lamport &&
        availableBalances.lamport.lamport > 0n &&
        availableBalances.wei.wei === 0n
      ) {
        // if the user only configured their SOL wallet, still show them ETH-only cards,
        // they might want to pay with by CC
        return 'fiat,sol';
      }
    }

    // no filter means all cards
    return null;
  }, [enabledWallets, availableBalances]);
};
